import useSsoReauthWarning from '../hooks/useSsoReauthWarning';
import SsoReauthModal from './SsoReauthModal/SsoReauthModal';

const SsoReauthWarningContainer = () => {
  const { isModalOpen, minutesRemaining, closeModal, handleReauthenticate } = useSsoReauthWarning();

  return (
    <SsoReauthModal
      isOpen={isModalOpen}
      minutesRemaining={minutesRemaining}
      onClose={closeModal}
      onReauthenticate={handleReauthenticate}
    />
  );
};

export default SsoReauthWarningContainer;
